// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".provider-list[data-v-040ae87f]{width:100%;display:flex;flex-direction:row;flex-wrap:wrap;justify-content:center}", ""]);
// Exports
module.exports = exports;
